"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cell = undefined;

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var Cell = exports.Cell = function Cell(props) {
  var children = props.children;
  return React.createElement(
    "div",
    {
      className: "jsx-165175979" + " " + ("cell " + (props.isSelected ? "focused" : "") + " " + (props._hovered ? "overrideHover" : ""))
    },
    React.createElement(_style2.default, {
      styleId: "165175979",
      css: ".cell.jsx-165175979{position:relative;background:var(--theme-cell-bg,white);-webkit-transition:all 0.1s ease-in-out;transition:all 0.1s ease-in-out;}.cell.overrideHover.jsx-165175979,.cell.jsx-165175979:hover{box-shadow:var( --theme-cell-shadow-hover, 1px 1px 3px rgba(0,0,0,0.12), -1px -1px 3px rgba(0,0,0,0.12) );}.cell.focused.jsx-165175979{box-shadow:var( --theme-cell-shadow-focus, 3px 3px 9px rgba(0,0,0,0.12), -3px -3px 9px rgba(0,0,0,0.12) );}.cell.overrideHover.jsx-165175979 .prompt,.cell.jsx-165175979:hover .prompt,.cell.jsx-165175979:active .prompt{background-color:var(--theme-cell-prompt-bg-hover,hsl(0,0%,94%));color:var(--theme-cell-prompt-fg-hover,hsl(0,0%,15%));}.cell.jsx-165175979:focus .prompt,.cell.focused.jsx-165175979 .prompt{background-color:var(--theme-cell-prompt-bg-focus,hsl(0,0%,90%));color:var(--theme-cell-prompt-fg-focus,hsl(0,0%,51%));}"
    }),
    children
  );
};

Cell.defaultProps = {
  isSelected: false,
  _hovered: false,
  children: null
};
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Cell, "Cell", "src/components/cell.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/presentational-components/lib/components/cell.js
// module id = 206
// module chunks = 186292428941015